var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dropdown", {
        staticClass: "position-static d-none d-lg-block",
        scopedSlots: _vm._u([
          {
            key: "trigger",
            fn: function(props) {
              return [
                _c(
                  "square-button",
                  {
                    attrs: {
                      to: "",
                      color: "#fff",
                      "is-active": props.isOpen,
                      "is-dark": false
                    }
                  },
                  [
                    _c("cart-icon", {
                      attrs: {
                        color: "#fff",
                        "items-count": _vm.basketitemsCount
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [_vm._v("Košík")])
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "body",
            fn: function() {
              return [
                _c("cart-dropdown", { attrs: { basketitems: _vm.basketitems } })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "square-button",
        {
          staticClass: "d-lg-none",
          attrs: {
            to: "",
            color: "#fff",
            "is-dark": false,
            "on-click": _vm.handleCartClick
          }
        },
        [
          _c("cart-icon", {
            attrs: { color: "#fff", "items-count": _vm.basketitemsCount }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "label" }, [_vm._v("Košík")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }